import { Card, CardBody, Col, CardHeader, Container, Form, FormGroup, Input, Label, Row, Table, Badge, Alert } from "reactstrap";
import { Btn, LI, P, UL, Image, Badges, H3, H5, SVG, H6, H4 } from "../../../AbstractElements";
import { EdminLogin, SearchTableButton } from "../../../utils/Constant";
import { generateRandomNumber, URL_API } from "../../../utils/helper/helpers";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { calculateDaysRemaining, formatDate, formatPhoneNumber, formatPrice, itemHasPermission } from "../../../utils/helper/helpers";
import SweetAlert from 'sweetalert2';
import { Link, useNavigate, useParams } from "react-router-dom";
// import { Chart } from "../BonDeCommande/apiBon";
import { dynamicImage } from "../../../Service";
import repousserPaiement, { AddNumBons, PaiementTransitaire, PayerVersement } from "../../../utils/helper/modal";
import { deleteNumBon, deletePaiement, deletePaiementTransitaire, validerUnPaiment } from "../apiVersement";
import TableauShowLaffrage from '../Tableau/laffrage';
import TableauShowDiamond from "../Tableau/diamond";
import TableauShowCimaf from "../Tableau/cimaf";
import html2pdf from "html2pdf.js";
import { useReactToPrint } from "react-to-print";

// Types
type Items = { [key: string]: any };


const ShowAutresVersement = () => {
    const Token = JSON.parse(localStorage.getItem("login")!);
    const [refresh, setRefresh] = useState(false);
    const [show, setShow] = useState(true);
    const [versements, setVersements] = useState<Items | null>(null);
    const [paiements, setPaiements] = useState<Items[]>([]);
    const [bons, setBons] = useState<Items[]>([]);
    const [identifyMat, setIdentifyMat] = useState<Items[]>([]);
    const [quantiteBonSortie, setQuantiteBonSortie] = useState<number>(0); // cette quantite est en tonne
    const [montantTotalPayer, setMontantTotalPayer] = useState<number>(0);
    const params = useParams();
    // modal
    const [staticModal, setStaticModal] = useState(false); // modal 1
    const [modalAdd, setModalAdd] = useState(false); // modal 2
    const [modalPaiement, setModalPaiement] = useState(false); // modal 3
    // parametre modal
    const [montantPayed, setMontantPayed] = useState<number | undefined>(undefined);//montant du paiement a effectuer pour le dernier paiement
    const staticModalToggle = () => setStaticModal(!staticModal); // toggle modal 1
    const staticModalAddNumBonToggle = () => setModalAdd(!modalAdd);// toggle modal 2
    const staticModalPaiementToggle = () => setModalPaiement(!modalPaiement); // toggle modal 3

    const openModalWithRow = () => {
        setStaticModal(true);
    };
    const openModalAddNumBons = () => {
        setModalAdd(true);
    };
    const openModalPaiement = (id: number, montant: number) => {
        setMontantPayed(montant);
        setModalPaiement(true);
    }
    const pdfRef = useRef<HTMLDivElement>(null);

    // Fetch data from API
    const fetchVersements = useCallback(async () => {
        try {
            const response = await axios.get(`${URL_API}/autres-versement/show/${params.id}`, {
                headers: { Authorization: `Bearer ${Token}` }
            });
            if (response.data.success) {
                setVersements(response.data.versements);
                setPaiements(response.data.paiement);
                setIdentifyMat(response.data.identify_mat);
                setBons(response.data.bons);
                setQuantiteBonSortie(response.data.Quantite_bons_sortie);
                setMontantTotalPayer(response.data.montant_payer);
            }
        } catch (error: any) {
            const message = error.response?.data?.message || "Erreur inconnue";
            toast.error(message);
        }
    }, []);

    const Confirmation = ({ id, action }: { id: number, action: string | null }) => {
            SweetAlert.fire({
                title: 'Êtes-vous sûr?',
                text: "De Vouloir Supprimer cet element ??",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Oui, Supprimer !'
            }).then((result) => {
                if (result.isConfirmed) {
                    if(action === 'supprimerPaiement'){
                        deletePaiementTransitaire({id: id }, () => setRefresh(!refresh));
                    }
                    if(action === 'supprimerNumBon'){
                        deleteNumBon({ id: id }, () => setRefresh(!refresh));
                    }
                    // deleteNumBon({ id: id }, () => setRefresh(!refresh));
                }
            });
        };

    const downloadRecu = async (id: string, url: string) => {
        if (!id) {
            return;
        }

        try {
            const response = await axios.get(`${URL_API}/download-recu/${id}`, {
                headers: { Authorization: `Bearer ${Token}` },
                responseType: 'blob',
            });

            const fileUrl = window.URL.createObjectURL(new Blob([response.data]));

            const link = document.createElement('a');
            link.href = fileUrl;
            link.setAttribute('download', "ReçuDePaiment" + url.split('/').pop() || 'document'); // Nom du fichier à télécharger
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            toast.info('Erreur lors du téléchargement du fichier');
        }
    };

    const handlePrint = useReactToPrint({
        content: () => pdfRef.current,
    });

    const onPrint = () => {
        setShow(false); // Masquer le contenu
        setTimeout(() => {
            handlePrint(); // Appeler la fonction d'impression
            setShow(true); // Réafficher après un délai
        }, 100); // Assurez-vous que le DOM a le temps de se mettre à jour
    };

    // const handlePrint = 
    const generatePDF = () => {
        setShow(false)
        const element = pdfRef.current;
        const name_document = generateRandomNumber(100000, 999999);
        if (element) {
            html2pdf()
                .from(element)
                .save(`synthese_caisse${name_document}.pdf`)
                .then(() => setShow(true))
                .catch(() => setShow(true));
        }
    };

    // Initial data fetch
    useEffect(() => {
        fetchVersements();
    }, [refresh, fetchVersements]);
    let montant = 0;
    return (
        <div className='page-body'>
            <Breadcrumbs mainTitle="Versements Details" parent="Versements" />
            <Container fluid>

                    <Card>
                        <CardBody>
                <div ref={pdfRef}>

                            <div className="text-center my-auto py-5">
                                <h1 className="text-uppercase fw-bold">{versements?.four_name}</h1>
                                <p className="f-20">{versements?.four_address}</p>
                                <p className="f-18">{formatPhoneNumber(versements?.four_phone)}</p>
                            </div>

                            <Row className="mx-3 my-4">
                                <Col lg={6} className="text-start text-uppercase">
                                    <p className="f-17"><span className="fw-bold">Nom du client </span> : {versements?.ets_name}</p>
                                    <p className="f-17"><span className="fw-bold" style={{ paddingRight: "92px" }}>Code </span>: {versements?.ets_code}</p>
                                    <p className="f-17"><span className="fw-bold" style={{ paddingRight: "110px" }}>Tel </span>: {formatPhoneNumber(versements?.ets_phone)}</p>
                                    <p className="f-17"><span className="fw-bold" style={{ paddingRight: "64px" }}>Adresse </span>: {versements?.ets_adresse}</p>
                                </Col>
                                {
                                    versements?.status === 'Payé' ? (
                                        <Col lg={6} className="text-end">

                                            <p className="f-17">Status: <Badges color="light-success">Payé</Badges></p>
                                            <p className="f-17">Date de paiement: <span className="text-uppercase fw-bold">{formatDate(versements?.updated_at)}</span></p>
                                            <p className="f-17">Montant payé: <span className="text-uppercase fw-bold">{formatPrice(montantTotalPayer)}</span></p>
                                        </Col>
                                    ) : (
                                        <Col lg={6} className="text-end">
                                            <p className="f-17">Date de paiement: <span className="text-uppercase fw-bold">{formatDate(versements?.created_at)}</span></p>
                                            <p className="f-17">Montant a payer: <span className="text-uppercase fw-bold">{(formatPrice(versements?.montant - montantTotalPayer))}</span></p>
                                        </Col>
                                    )
                                }
                            </Row>

                            <div className="mx-3 mt-5">
                                <Table bordered responsive className="text-center">
                                    <thead>
                                        <tr className="f-17">
                                            <th scope="col">DATE PAIEMENT</th>
                                            <th scope="col">TYPE DE MATERIEL</th>
                                            <th scope="col">QUANTITE TONNE</th>
                                            <th scope="col">PRIX UNITAIRES</th>
                                            <th scope="col">MONTANT</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {identifyMat.map((item, index) => (
                                            <tr className="f-17" key={item.id || index}>
                                                {index === 0 && (
                                                    <td rowSpan={identifyMat.length} className="text-capitalize fw-bold">
                                                        {formatDate(versements?.created_at)}
                                                    </td>
                                                )}
                                                <td className="text-capitalize">{item.materiel}</td>
                                                <td>{parseInt(item.quantite_tonne, 10).toLocaleString("gn-GN")} Tonnes</td>
                                                <td>{formatPrice(item.montant)}</td>
                                                {index === 0 && (
                                                    <td rowSpan={identifyMat.length} className="fw-bold">
                                                        {
                                                            versements?.status === 'Attente' ? (
                                                                <>
                                                                    <p className="bg-light-success">TOTAL : <span className="text-uppercase fw-bold">{formatPrice(versements?.montant)}</span> </p>
                                                                    <p className="bg-light-dark my-1">PAYÉ : <span className="text-uppercase fw-bold">{formatPrice(montantTotalPayer)}</span></p>
                                                                    <p className="bg-light-warning">RESTE : <span className="text-uppercase fw-bold">{formatPrice(Number(versements?.montant) - Number(montantTotalPayer))}</span></p>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <p className="bg-light-success">TOTAL : <span className="text-uppercase fw-bold">{formatPrice(versements?.montant)}</span> </p>
                                                                    <p className="bg-light-dark my-1">PAYÉ : <span className="text-uppercase fw-bold">{formatPrice(montantTotalPayer)}</span> </p>
                                                                    <p className="bg-light-info">AVANCÉ : <span className="text-uppercase fw-bold">{formatPrice(Number(versements?.montant) - Number(montantTotalPayer))}</span></p>
                                                                </>
                                                            )
                                                        }
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                        <tr>
                                            <td colSpan={2} className="text-center fw-bold">TOTAL</td>
                                            <td  className="text-center bg-light-info fw-bold">
                                                {versements?.quantite_tonne} TONNES
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                                <Row>
                                    <Col sm="5" className="mt-4" >

                                        <p className="f-17"> Enrégistré par : <span className="fw-bold">{versements?.users_name + " " + versements?.users_firstname}</span></p>
                                        {
                                            versements?.users_signature
                                                ? (<Image src={versements?.users_signature} alt="User signature" />)
                                                : (null)
                                        }
                                        <p className="f-17"> Téléphone : <span className="fw-bold">{formatPhoneNumber(versements?.users_phone)}</span></p>
                                    </Col>
                                    {show && (
                                        <Col sm="7" className="text-end mt-4">
                                            <Btn color="light-info" onClick={onPrint} className="btn btn-xs mx-1 p-1 px-3">
                                                <i className="fa fa-print"></i> Imprimer
                                            </Btn>
                                            {versements?.justificatif && (
                                                <Btn color="light-info" onClick={() => downloadRecu(versements?.pv_id, versements?.justificatif)} className="btn btn-xs mx-1 p-1 px-3">
                                                    <i className="fa fa-download"></i> Télécharger le justificatif valide
                                                </Btn>
                                            )}
                                            {versements?.quantite_tonne > quantiteBonSortie && (
                                                (itemHasPermission("super admin") || itemHasPermission('gest. versements ecriture') || itemHasPermission('gest. bons ecriture')) && (
                                                    <>
                                                        <Btn color="light-dark" onClick={openModalAddNumBons} className="btn btn-xs mx-1 p-1 px-3 for-light">
                                                            <i className="fa fa-plus"></i> Ajouter N° de bons
                                                        </Btn>
                                                        <Btn color="light-light" onClick={openModalAddNumBons} className="btn btn-xs mx-1 p-1 px-3 for-dark">
                                                            <i className="fa fa-plus"></i> Ajouter N° de bons
                                                        </Btn>
                                                    </>
                                                )
                                            )}
                                            <Link to="/autres-versement" className="btn btn-xs mx-1 p-1 px-3 btn-light-danger">
                                                <i className="fa fa-sign-out"></i> Quitter
                                            </Link>
                                        </Col>
                                    )}

                                </Row>
                             </div>
                            </div>
                        </CardBody>
                    </Card>

                    <Row>
                        <Col sm={3}>
                            <Card className="invoice-card">
                                <CardHeader className="pb-0 text-center">
                                    <H4 className="f-20"> Numéro des bons</H4>
                                    <p className="text-success fw-bold">Quantite Tonne Sortie : {quantiteBonSortie.toLocaleString('fr-FR')}</p>
                                </CardHeader>
                                <CardBody className="invoice-table pt-0 checkbox-checked">
                                    <Table responsive id="all-invoice">
                                        <thead className="bg-info">
                                            <tr>
                                                <th className="text-white">Numéro</th>
                                                <th className="text-white text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            
                                            {bons && bons.length > 0 ? bons.map((item, index) => (
                                                <tr key={index}>
                                                    <td>#{item.num} <span className="text-success">({item.bons_qt ?? 0} T)</span></td>
                                                    <td className="text-center">
                                                        {
                                                            item.bons_id === null ? (
                                                            <Btn color="light-danger" onClick={() => Confirmation({id: item.id, action: 'supprimerNumBon'})} className="btn btn-xs mx-1 p-1 px-3">
                                                                <i className="fa fa-trash"></i>
                                                            </Btn>
                                                            ) : (
                                                                <>
                                                                    <Link className='btn bg-light-dark btn-xs mx-1 for-light' to={`/show-autres-bon-de-commande/${item.bons_id}`}>
                                                                        <i className='fa fa-eye'></i>
                                                                    </Link>
                                                                    <Link className='btn btn-light-light btn-xs mx-1 for-dark' to={`/show-autres-bon-de-commande/${item.bons_id}`}>
                                                                        <i className='fa fa-eye'></i>
                                                                    </Link>
                                                                </>
                                                            )
                                                        }
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan={5} className="text-center">Aucun paiement trouvé.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col sm={9}>
                            <Card className="invoice-card">
                                <CardHeader className="pb-0">
                                    <H4 className="f-30 text-center"><i className="icofont icofont-money f-40 text-success"></i> Details Paiements <i className="icofont icofont-money f-40 text-success"></i></H4>
                                </CardHeader>
                                <CardBody className="invoice-table pt-0 checkbox-checked">
                                    <Table responsive id="all-invoice">
                                        <thead className="bg-info">
                                            <tr>
                                                <th className="text-white text-center">No.</th>
                                                <th className="text-white text-center">Montant</th>
                                                <th className="text-white text-center">Descriptions</th>
                                                <th className="text-white">Montant Payé</th>
                                                <th className="text-white text-center">Montant Restant</th>
                                                <th className="text-white text-center">Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* Première ligne */}
                                            <tr>
                                                <td className="text-center">####</td>
                                                <td>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <div className="flex-shrink-0">
                                                            <i className="icofont icofont-money-bag f-40 text-success"></i>
                                                        </div>
                                                        <div className="flex-grow-1">
                                                            <Link to="#">
                                                                <H6 className="f-w-500">{formatPrice(versements?.montant)}</H6>
                                                            </Link>
                                                            <span className="font-light text-capitalize f-w-400 f-13"> {formatDate(versements?.created_at)} </span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="text-center"></td>
                                                <td className="text-center bg-light-success">{formatPrice(0.00)}</td>
                                                <td className="text-center bg-light-danger">{formatPrice(versements?.montant)}</td>
                                                <td className="text-center">
                                                {(itemHasPermission("super admin") || itemHasPermission('gest. versements ecriture') || itemHasPermission('gest. bons ecriture')) && (
                                                    <Btn color="light-dark" onClick={() => openModalWithRow()} className="btn btn-xs mx-1 p-1 px-3">
                                                        <i className="fa fa-money"></i> Effectuer le Paiement
                                                    </Btn>
                                                )}
                                                </td>
                                            </tr>

                                            {/* Ligne des paiements */}
                                            {paiements && paiements.length > 0 ? (
                                                paiements.map((item, index) => {
                                                    montant += Number(item.montant);
                                                    return (
                                                        <tr key={index}>
                                                            <td className="text-center">#{item.num_paiement}</td>
                                                            <td>
                                                                {item.status === "Invalide" ? (
                                                                    <div className="d-flex align-items-center gap-2">
                                                                        <div className="flex-shrink-0">
                                                                            <i className="icofont icofont-money-bag f-40 text-success"></i>
                                                                        </div>
                                                                        <div className="flex-grow-1">
                                                                            <Link to="#">
                                                                                <H6 className="f-w-500">{formatPrice(item.montant)}</H6>
                                                                            </Link>
                                                                            <span className="text-success text-capitalize f-w-400 f-13"> Paiement Effectué </span>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div className="d-flex align-items-center gap-2">
                                                                        <div className="flex-shrink-0">
                                                                            <i className="icofont icofont-money-bag f-40 text-success"></i>
                                                                        </div>
                                                                        <div className="flex-grow-1">
                                                                            <Link to="#">
                                                                                <H6 className="f-w-500">{formatPrice(item.montant)}</H6>
                                                                            </Link>
                                                                            <span className="font-light text-capitalize f-w-400 f-13"> {formatDate(item.date_paiement)} </span>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td>
                                                                <span className="fw-bold">{item.mode_de_paiement}</span> / {item.receveur}
                                                            </td>
                                                            <td className="text-center bg-light-success">
                                                                {formatPrice(item.montant)}
                                                            </td>
                                                            <td className="text-center bg-light-danger">
                                                                {formatPrice(Number(versements?.montant) - Number(montant))}
                                                            </td>
                                                            <td className="text-center">
                                                                {item.justificatif == "" || item.justificatif == null ? (
                                                                    <span>Aucun Justificatif</span>
                                                                ) : (
                                                                    <Btn
                                                                        color="light-info"
                                                                        onClick={() =>
                                                                            downloadRecu(item.id, versements?.justificatif)
                                                                        }
                                                                        className="btn btn-xs mx-1 p-1 px-3"
                                                                    >
                                                                        <i className="fa fa-download"></i> Télécharger
                                                                    </Btn>
                                                                )}
                                                                <Btn color="light-danger " onClick={() => Confirmation({id: item.id, action: 'supprimerPaiement'})} className="btn btn-xs mx-1 p-1 px-3">
                                                                    <i className="fa fa-trash"></i>
                                                                </Btn>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan={6} className="text-center">
                                                        Aucun paiement trouvé.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
            </Container>
            {
                PaiementTransitaire({
                    isOpen: staticModal,
                    montant: Number(versements?.montant) - Number(montantTotalPayer),
                    versement_id: params.id ? parseInt(params.id) : 0,
                    toggle: staticModalToggle,

                }, () => setRefresh(!refresh))
            }{
                AddNumBons({
                    isOpen: modalAdd,
                    versement_id: versements?.id ? versements?.id : 0,
                    fournisseur_id: versements?.four_id,
                    four_type: versements?.four_type,
                    toggle: staticModalAddNumBonToggle,
                }, () => setRefresh(!refresh))
            }{
                PayerVersement({
                    isOpen: modalPaiement,
                    montant_a_payer: montantPayed ?? 0,
                    versement_id: versements?.id ?? 0,
                    toggle: staticModalPaiementToggle,
                }, () => setRefresh(!refresh))
            }
        </div >

    )
}

export default ShowAutresVersement;